// jQuery plugin - used for DataTables.net
import $ from "jquery";
import './select.css';
// DataTables.net plugin - creates a tables with actions on it
//require("datatables.net-responsive");
$.DataTable = require("datatables.net-bs")

var selected = [];

export function refreshSelected() {
  selected = [];
}

export function mountTable(url, identifier, editAction, deleteAction, customAction, selectable, idCol, filterClasses, fixedColWidth, responsive, notify) {
  window.console.log(identifier)
  $(`#${identifier}`).DataTable({
    serverSide: true,
    processing: true,
    stateSave: true,
    rowCallback: function( row, data ) {  // marcar como seleccionados cuando se cambia la paginacion
      if ($.inArray(data[5], selected) !== -1 ) {
        $(row).addClass('selected');
        $(':checkbox', row).prop('checked', true);
      }
    },
    ajax: {
      headers: {
        Accept: "application/json; charset=utf-8",
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("id_token")
      },
      data: function(d) {
        let filters = {};
        if (filterClasses) {
          filterClasses.forEach((filter) => {
            filters[filter.name] = JSON.parse($(`.${filter.value}`).val());
          });
        }
        return { params: d , filters };
      },
      url: url,
      type: "GET"
    },
    pagingType: "full_numbers",
    lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "Todo"]],
    responsive: responsive ? responsive : true,
    language: {
      search: "_INPUT_",
      searchPlaceholder: "Buscar",
      lengthMenu: "Mostrar _MENU_ resgistros por página",
      zeroRecords: "No hay registros",
      info:
        "Mostrando página _PAGE_ de _PAGES_, Registros _START_ al _END_ de _TOTAL_",
      infoEmpty: "No hay registros",
      infoFiltered: "filtrados de _MAX_ registros totales",
      paginate: {
        first: "Primera",
        last: "Última",
        next: "Siguiente",
        previous: "Anterior"
      }
    },
    createdRow: function(row, data, index) {
      if (fixedColWidth) {  // fix problema con RendicionFondosTab ancho incorrecto primer columna
        $(`td:eq(${fixedColWidth.col})`, row).attr('colspan', fixedColWidth.value);
      }
      $(window).resize(function() {
        if (fixedColWidth) {
          $(`td:eq(${fixedColWidth.col})`, row).attr('colspan', fixedColWidth.value);
        }
      });
      var columnsLength = $("td", row).length;
      if (selectable) {
        row.id = data[idCol]; // set row id
      }
      $(`td:eq(${columnsLength-1})`, row).empty();
      if (notify) {
        console.log(notify);
        $(row).addClass(data[notify] === 'SI' ? 'notify' : '');
      }
      if (editAction) {
        var btnedit = $(
          '<a class="btn btn-simple btn-warning btn-icon edit"><i class="fa fa-edit text-right"></i></a>'
        );
        btnedit.on("click", () => editAction(data));
        $(`td:eq(${columnsLength-1})`, row).append(btnedit);
      }
      if (deleteAction) {
        var btndele = $(
          '<a class="btn btn-simple btn-danger btn-icon remove"><i class="fa fa-times text-right"></i></a>'
        );
        btndele.on("click", function() {
          deleteAction(data);
        });
        $(`td:eq(${columnsLength-1})`, row).append(btndele);
      }
      if (customAction) {
        customAction.forEach((action) => {
          var component = $(action.htmlString);
          if (action.checkMe) {
            component.prop('checked', parseInt(data[action.columnCheck], 10));
          }
          if (action.disableMe) {
            component.attr('disabled', !data[action.columnDisable] && 'disabled');
          }
          selected && component.css('display', 'unset');
          var props = null;
          if (data.length > columnsLength) {
            props = data[data.length-1];
            if (component.is(':button')) {
              props.text && component.html(props.text);
              props.btnclass && component.addClass(props.btnclass);
              props.disabled && component.attr('disabled', 'disabled');
            }
          }
            component.on(action.actionString, function() {
              if (selectable) {
                var id = row.id;
                var index = $.inArray(id, selected);
                if ( index === -1 ) {
                  selected.push( id );
                } else {
                  selected.splice( index, 1 );
                }
                $(row).toggleClass('selected');
              }
              action.actionFunction(data, selected, component.is(':checked'));
            });
          $(`td:eq(${columnsLength-1})`, row).append(component);
        });
      }
      $(`td:eq(${columnsLength-1})`, row).css('text-align', 'right');
      $(`td:eq(${columnsLength-1})`, row).css('white-space', 'nowrap');
    }
  });
}

export function getTable(identifier) {
  var table = $(`#${identifier}`).DataTable();
  return table;
}

export function unmountTable(identifier) {
  var table = $(`#${identifier}`).DataTable();
  table.destroy(true);
}



// WEBPACK FOOTER //
// ./src/views/Components/JQueryTable/JQueryTableLogic.jsx